import { render, staticRenderFns } from "./AdminClientAnalyze.vue?vue&type=template&id=4bbc2776&scoped=true&"
import script from "./AdminClientAnalyze.vue?vue&type=script&lang=js&"
export * from "./AdminClientAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientAnalyze.vue?vue&type=style&index=0&id=4bbc2776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc2776",
  null
  
)

export default component.exports